var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (Object.keys(_vm.tableData).length != 0)?_c('v-simple-table',{staticClass:"px-5",scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('thead',[_c('tr',[_c('th',{staticClass:"text-center"}),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t(["Amount"])))]),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t(["Refunded"])))]),_c('th',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.$t(["Total"])))])])]),_c('tbody',[(_vm.tableData.type == 'Merchandise')?_c('tr',{staticClass:"text-center"},[_c('td',{staticClass:"pl-0"},[_vm._v(_vm._s(_vm.$t(["Merchandise"])))]),_c('td',{domProps:{"innerHTML":_vm._s(
            _vm.$t('Currency', { amount: _vm.tableData.merchAmount.toFixed(2) })
          )}}),_c('td',{staticClass:"secondary--text",domProps:{"innerHTML":_vm._s(
            '(' +
            _vm.$t('Currency', { amount: _vm.tableData.merchRefund.toFixed(2) }) +
            ')'
          )}}),_c('td',{domProps:{"innerHTML":_vm._s(_vm.$t('Currency', { amount: _vm.tableData.merchTotal.toFixed(2) }))}})]):_vm._e(),_c('tr',{staticClass:"text-center"},[_c('td',{staticClass:"pl-0"},[_vm._v(_vm._s(_vm.$t(["Donation"])))]),_c('td',{domProps:{"innerHTML":_vm._s(
            _vm.$t('Currency', { amount: _vm.tableData.donationAmount.toFixed(2) })
          )}}),_c('td',{staticClass:"secondary--text",domProps:{"innerHTML":_vm._s(
            '(' +
            _vm.$t('Currency', { amount: _vm.tableData.donationRefund.toFixed(2) }) +
            ')'
          )}}),_c('td',{domProps:{"innerHTML":_vm._s(
            _vm.$t('Currency', { amount: _vm.tableData.donationTotal.toFixed(2) })
          )}})]),_c('tr',{staticClass:"text-center"},[_c('td',{staticClass:"pl-0"},[_c('h2',[_vm._v(_vm._s(_vm.$t(["Total"])))])]),_c('td',[_c('h2',{domProps:{"innerHTML":_vm._s(
              _vm.$t('Currency', {
                amount: (
                  (!isNaN(_vm.tableData.merchAmount)
                    ? _vm.tableData.merchAmount
                    : 0) + _vm.tableData.donationAmount
                ).toFixed(2),
              })
            )}})]),_c('td',[_c('h2',{staticClass:"secondary--text",domProps:{"innerHTML":_vm._s(
              '(' +
              _vm.$t('Currency', {
                amount: (
                  (!isNaN(_vm.tableData.merchRefund)
                    ? _vm.tableData.merchRefund
                    : 0) + _vm.tableData.donationRefund
                ).toFixed(2),
              }) +
              ')'
            )}})]),_c('td',[_c('h2',{domProps:{"innerHTML":_vm._s(
              _vm.$t('Currency', {
                amount: (
                  (!isNaN(_vm.tableData.merchTotal) ? _vm.tableData.merchTotal : 0) +
                  _vm.tableData.donationTotal
                ).toFixed(2),
              })
            )}})])])])]},proxy:true}],null,false,2980265032)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }